import styled from '@emotion/styled';

import { navAsset } from './navConfig';

const Root = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  padding: 0 4px;
  flex-shrink: 0;
`;

const HeaderTitle = styled.span`
  padding: 0 8px;
  font-size: 18px;
  line-height: 23.2px;
  color: #000000;
  white-space: nowrap;
`;

const IconGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const IconButton = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  background: transparent;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(17, 17, 0, 0.04);
  }
`;

const Conversation = styled.div`
  flex: 1 0 0;
  min-height: 0;
`;

const PromptInput = styled.div`
  flex-shrink: 0;
  background: #fafafa;
  border-radius: 24px;
  box-shadow: 0 8px 20px 4px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const PromptContainer = styled.div`
  border: 1px solid rgba(255, 255, 255, 0.98);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  padding: 0 16px 16px;
`;

const PromptTextArea = styled.textarea`
  width: 100%;
  border: none;
  outline: none;
  resize: none;
  background: transparent;
  padding: 24px 12px 12px;
  font-size: 14px;
  line-height: 20px;
  color: #111100;
  max-height: 134px;

  &::placeholder {
    color: rgba(17, 17, 7, 0.6);
  }
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 8px;
`;

const SendIcon = styled.img`
  transform: rotate(-90deg);
`;

const SendButton = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 500px;
  background: rgba(14, 14, 3, 0.09);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(14, 14, 3, 0.16);
  }
`;

type ChatPanelProps = {
  onClose: () => void;
};

export function ChatPanel({ onClose }: ChatPanelProps) {
  return (
    <Root data-testid="nav_chat-panel">
      <Header>
        <HeaderTitle>New chat</HeaderTitle>
        <IconGroup>
          <IconButton type="button" aria-label="New chat">
            <img src={navAsset('chat-new')} alt="" width={16} height={16} />
          </IconButton>
          <IconButton type="button" aria-label="History">
            <img src={navAsset('chat-history')} alt="" width={16} height={16} />
          </IconButton>
          <IconButton type="button" aria-label="Close" onClick={onClose}>
            <img src={navAsset('chat-close')} alt="" width={12} height={16} />
          </IconButton>
        </IconGroup>
      </Header>

      <Conversation />

      <PromptInput>
        <PromptContainer>
          <PromptTextArea
            rows={1}
            placeholder="Ask Flodesk AI to..."
            data-testid="nav_chat_prompt-input"
          />
          <Controls>
            <IconButton type="button" aria-label="Attach file">
              <img src={navAsset('clip')} alt="" width={14} height={16} />
            </IconButton>
            <SendButton type="button" aria-label="Send">
              <SendIcon src={navAsset('send')} alt="" width={14} height={18} />
            </SendButton>
          </Controls>
        </PromptContainer>
      </PromptInput>
    </Root>
  );
}
